import { createSlice } from "@reduxjs/toolkit";
import {
  addCompanyDetails,
  addJobPostByHireTalent,
  fetchHireTalentProfile,
  getJobPostData,
  hireTalentSignUp,
  updateHireTalentSection2,
  updateHireTalentSection3,
  updateHireTalentSection4,
  updateHireTalentProfileStep,
  raiseHireTalentTicket,
  fetchHireTalentTickets,
  fetchHireTalentJobApplications,
  scheduleHireTalentInterview,
  rejectHireTalentApplicant,
  fetchHireTalentDashboard,
} from "../actions/authAction";

const initialState = {
  isLoading: false,
  subLoading: false,
  isHireTalentModal: false,
  pagename: "signup",
  startStep: 1,
  jobPostList: {},
  ticketList: [],
  jobApplications: [],
  dashboardData: {},
  JobHeader: [
    "S.No.",
    "Job Title",
    "Category",
    "Status",
    "Location",
    "Action"
  ],
};

const hireTalentSlice = createSlice({
  name: "hire-talent",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.pagename = action.payload;
    },
    setIsHireTalentModal: (state, action) => {
      state.isHireTalentModal = action.payload;
    },
    setStartStep: (state, action) => {
      state.startStep = action.payload;
    },
  },
  extraReducers: (builder) => {
    // hire-talent-sign-up
    builder.addCase(hireTalentSignUp.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(hireTalentSignUp.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(hireTalentSignUp.rejected, (state, action) => {
      state.subLoading = false;
    });
    // add-company-details
    builder.addCase(addCompanyDetails.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(addCompanyDetails.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(addCompanyDetails.rejected, (state, action) => {
      state.subLoading = false;
    });

    // update-section-2
    builder.addCase(updateHireTalentSection2.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(updateHireTalentSection2.fulfilled, (state) => {
      state.subLoading = false;
    });
    builder.addCase(updateHireTalentSection2.rejected, (state) => {
      state.subLoading = false;
    });

    // update-section-3
    builder.addCase(updateHireTalentSection3.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(updateHireTalentSection3.fulfilled, (state) => {
      state.subLoading = false;
    });
    builder.addCase(updateHireTalentSection3.rejected, (state) => {
      state.subLoading = false;
    });

    // update-section-4
    builder.addCase(updateHireTalentSection4.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(updateHireTalentSection4.fulfilled, (state) => {
      state.subLoading = false;
    });
    builder.addCase(updateHireTalentSection4.rejected, (state) => {
      state.subLoading = false;
    });

    // fetch profile
    builder.addCase(fetchHireTalentProfile.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(fetchHireTalentProfile.fulfilled, (state) => {
      state.subLoading = false;
    });
    builder.addCase(fetchHireTalentProfile.rejected, (state) => {
      state.subLoading = false;
    });

    // update profile
    builder.addCase(updateHireTalentProfileStep.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(updateHireTalentProfileStep.fulfilled, (state) => {
      state.subLoading = false;
    });
    builder.addCase(updateHireTalentProfileStep.rejected, (state) => {
      state.subLoading = false;
    });

    // addJobPostByHireTalent
    builder.addCase(addJobPostByHireTalent.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(addJobPostByHireTalent.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(addJobPostByHireTalent.rejected, (state, action) => {
      state.subLoading = false;
    });

    // getJobPostData
    builder.addCase(getJobPostData.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(getJobPostData.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      // state.jobPostList = data || [];
      state.subLoading = false;
      const grouped = Object?.groupBy(data||[], (p) => p?.status);
      state.jobPostList = {
        all: data,
        ...grouped,
      };
    });
    builder.addCase(getJobPostData.rejected, (state, action) => {
      state.subLoading = false;
    });

    // raise-hire-talent-ticket
    builder.addCase(raiseHireTalentTicket.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(raiseHireTalentTicket.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(raiseHireTalentTicket.rejected, (state) => {
      state.isLoading = false;
    });

    // fetch-hire-talent-tickets
    builder.addCase(fetchHireTalentTickets.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(fetchHireTalentTickets.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.ticketList = data || [];
      state.subLoading = false;
    });
    builder.addCase(fetchHireTalentTickets.rejected, (state) => {
      state.subLoading = false;
    });

    // fetch-hire-talent-job-applications
    builder.addCase(fetchHireTalentJobApplications.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(fetchHireTalentJobApplications.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.jobApplications = data || [];
      state.subLoading = false;
    });
    builder.addCase(fetchHireTalentJobApplications.rejected, (state) => {
      state.subLoading = false;
    });

    // fetch-hire-talent-dashboard
    builder.addCase(fetchHireTalentDashboard.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(fetchHireTalentDashboard.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.dashboardData = data || {};
      state.subLoading = false;
    });
    builder.addCase(fetchHireTalentDashboard.rejected, (state) => {
      state.subLoading = false;
    });

    // schedule-hire-talent-interview
    builder.addCase(scheduleHireTalentInterview.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(scheduleHireTalentInterview.fulfilled, (state) => {
      state.subLoading = false;
    });
    builder.addCase(scheduleHireTalentInterview.rejected, (state) => {
      state.subLoading = false;
    });

    // reject-hire-talent-applicant
    builder.addCase(rejectHireTalentApplicant.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(rejectHireTalentApplicant.fulfilled, (state) => {
      state.subLoading = false;
    });
    builder.addCase(rejectHireTalentApplicant.rejected, (state) => {
      state.subLoading = false;
    });
  },
});

export default hireTalentSlice.reducer;
export const { setPage, setIsHireTalentModal, setStartStep } = hireTalentSlice.actions;
